import {DateBaseAttribute, DateBaseAttributeOptions} from './DateBaseAttribute';

export type DateAttributeOptions = DateBaseAttributeOptions;

export class DateAttribute extends DateBaseAttribute {
  constructor(options: DateAttributeOptions = {}) {
    super(options);
  }

  // Input type that is used if attribute is used in edit mode
  get inputType(): string {
    return 'date';
  }

  /** For the date attribute, we only keep the date part */
  toDbValue(value: unknown): [unknown, unknown] {
    if (!value) return [null, null];
    let date = null;
    if (value instanceof Date) date = value;
    if (typeof value === 'string' || typeof value === 'number')
      date = new Date(value);
    if (date) return [date.toISOString().split('T')[0], date];
    return [null, null];
  }
}
